import styled from "styled-components";

type ContainerType = {
    background: string;
};

export const ContainerDetailAndTitle = styled.div<ContainerType>`
    display: flex;
    flex-direction: column;
    background: ${(props) => props.background};
    border-radius: 8px;
    width: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const Title = styled.span`
  font-size: 15px;
  color: ${(props) => props.color};
  letter-spacing: .1px;
  font-weight: 600;
`;

export const Description = styled.span`
    font-size: 12px;
    color: ${(props) => props.color};
    margin-top: -2px;
`;

export const ContentTitle = styled.div`
    justify-content: space-around;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 8px 16px;
`;

export const ContainerDetail = styled.div`
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`;
